
<template>
    <div
        class="
            bg-blue-100
            border-t border-b border-blue-500
            text-blue-700
            px-4
            py-4
        "
        :class="[
            type == 'warning' ? warning : type == 'danger' ? danger : info,
        ]"
        role="alert"
    >
        <p class="font-bold" v-if="header">{{ header }}</p>
        <p class="text-sm">{{ msg }}</p>
    </div>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
    props: ["type", "header", "msg"],
    data() {
        return {
            info: "bg-blue-200 border-t-2 border-b border-blue-600 text-blue-800",
            warning:
                "bg-yellow-200 border-t-2 border-b border-rose-600 text-rose-800",
            danger: "bg-red-200 border-t-2 border-b border-red-600 text-red-800",
        };
    },
});
</script>